<template>
  <component
    :is="Footer"
    v-if="footer || footer === undefined"
    :key="`footer_${locale}`"
    v-bind="{ ...$attrs, ...$props }"
    :variant="footer"
  />
</template>

<script lang="ts" setup>
import type { TheFooterVariant } from './types'

export type TheFooterProps = { variant?: TheFooterVariant }

const Footer = defineAsyncComponent(() => import('./TheFooterImplementation.vue'))

const props = defineProps<TheFooterProps>()
const { currentRoute } = useRouter()
const { locale } = useI18n()

const footer = computed(() => props.variant ?? (currentRoute.value.meta.footer as TheFooterVariant))
</script>
